import { useStore, State } from 'store';

const selector = (state: State) => {
  return state.startWorkflow.steps.currentStepIndex;
};

export default function useCurrentStepIndex() {
  return useStore(selector);
}
